import { render } from "./ProductRegistrationAdd.vue?vue&type=template&id=f6100c74"
import script from "./ProductRegistrationAdd.vue?vue&type=script&lang=js"
export * from "./ProductRegistrationAdd.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__